export default __webpack_public_path__ + "static/media/money-back.fa8c16cc.png";